<template>
  <div class="index" @click="hidedialog">
    <headerview></headerview>
    <div class="content">
      <div class="content-left">
        <el-menu
          :default-active="defaultAction"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-menu-item
            index="/helpcenterindex/help"
            @click="linkto('/helpcenterindex/help')"
          >
            <span slot="title" style="font-size: 16px">悦享工资条帮助文档</span>
          </el-menu-item>
          <el-menu-item
            index="/helpcenterindex/smshelp"
            @click="linkto('/helpcenterindex/smshelp')"
          >
            <span slot="title" style="font-size: 16px">短信中心帮助文档</span>
          </el-menu-item>
          <el-menu-item
            index="/helpcenterindex/cardhelp"
            @click="linkto('/helpcenterindex/cardhelp')"
          >
            <span slot="title" style="font-size: 16px">悦享心语帮助文档</span>
          </el-menu-item>
        </el-menu>
        <img src="@/assets/IMG003.png" alt="" />
      </div>
      <div class="content-right">
        <router-view style=""></router-view>
      </div>
    </div>
    <!-- <el-row>
      <el-col :span="3" class="left">
        <el-menu
          default-active="/index/new"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-menu-item index="/index/new" @click="linkto('/index/new')">
            <i class="el-icon-document-add"></i>
            <span slot="title">新建</span>
          </el-menu-item>
          <el-menu-item
            index="/index/history"
            @click="linkto('/index/history')"
          >
            <i class="el-icon-document"></i>
            <span slot="title">发送记录</span>
          </el-menu-item>
          <el-menu-item index="/index/provid" @click="linkto('/index/provid')">
            <i class="el-icon-money"></i>
            <span slot="title">我的套餐</span>
          </el-menu-item>
          <el-menu-item index="/index/system" @click="linkto('/index/system')">
            <i class="el-icon-coin"></i>
            <span slot="title">系统集成</span>
          </el-menu-item>
          <el-menu-item index="" @click="linkto('')">
            <i class="el-icon-setting"></i>
            <span slot="title">设置</span>
          </el-menu-item>
        </el-menu>
        <img src="" alt="" />
      </el-col>
      <el-col :span="21">
        <router-view style=""></router-view>
      </el-col>
    </el-row> -->
    <tip></tip>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, Upload } from "iview";
import Cookie from "js-cookie";

import headerview from "@/components/helpcenterheader.vue";
import tip from "@/components/tip.vue";

export default {
  name: "index",
  components: {
    Upload,
    Button,
    headerview,
    tip,
  },
  data() {
    return {
      menuName: "",
      siteUrl: this.$http.defaults.url_base,
      defaultAction: "",
    };
  },
  methods: {
    hidedialog(e) {
      if (e.target.className != "tipList") {
        this.$store.state.showTip = false;
      }
    },
    // toindex () {
    //   this.$router.push('index')
    // },
    // tootherindex () {
    //   let routeUrl = this.$router.resolve({
    //     path: '/enterpriseIndex'// 这里的路径就可以正常的写，不需要添加_blank: true
    //   })
    //   window.open(routeUrl.href, '_blank')
    //   // this.$router.push('')
    // },
    linkto(path) {
      console.log(path);
      this.$router.push(path);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSuccess(response) {},
    onerror() {
      this.$message({
        type: "info",
        message: "上传失败",
      });
    },
    logout() {
      window.sessionStorage.removeItem("token");
      this.$router.replace("/login");
      window.location.reload();
    },
  },
  mounted() {
    this.defaultAction = this.$route.path;
  },
  computed: {
    nameChange() {
      return this.$store.state.modifyName;
    },
  },
  watch: {
    nameChange(val) {
      console.log(val);
      if (val) {
        // this.menuName = JSON.parse(Cookie.get('userInfo')).abbreviation
        //
        this.$store.commit("modifyName", false);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .header-wrap {
//   border-bottom: 1px solid rgba(204, 204, 204, 0.3);
//   header {
//     width: 95%;
//     height: 79px;
//     margin: 0 auto;
//     display: flex;
//     justify-content: space-between;
//     .header-left {
//       display: flex;
//       align-items: center;
//       justify-content: left;
//     }
//     .header-right {
//       display: flex;
//       align-items: center;
//       justify-content: left;
//       .otherapp {
//         width: 120px;
//         height: 40px;
//         background: #3bc492;
//         box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
//         border-radius: 4px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         cursor: pointer;
//         img {
//           height: 14px;
//         }
//         span {
//           font-size: 16px;
//           font-family: PingFangSC-Medium, PingFang SC;
//           font-weight: 500;
//           color: #ffffff;
//           line-height: 24px;
//           margin-left: 8px;
//         }
//       }
//       .company-name {
//         font-size: 16px;
//         font-family: PingFangSC-Regular, PingFang SC;
//         font-weight: 400;
//         color: #0a1629;
//         line-height: 24px;
//       }
//       .line {
//         width: 1px;
//         height: 44px;
//         opacity: 0.1;
//         border: 1px solid #000000;
//         margin: 0 15px;
//       }
//       .el-dropdown-link {
//         font-size: 16px;
//         font-family: PingFangSC-Regular, PingFang SC;
//         font-weight: 400;
//         color: #0a1629;
//         line-height: 24px;
//       }
//       .msg {
//         display: flex;
//         align-items: center;
//         justify-content: left;
//         cursor: pointer;
//         span {
//           font-size: 16px;
//           font-family: PingFangSC-Regular, PingFang SC;
//           font-weight: 400;
//           color: #0a1629;
//           line-height: 24px;
//           margin-left: 9px;
//         }
//         img {
//           height: 17px;
//         }
//       }
//     }
//   }
// }
.content {
  display: flex;
  .content-left {
    width: 185px;
    height: calc(100vh - 80px);
    position: relative;
    /deep/.is-active {
      background: #3bc492;
      color: #fff;
      border-left: 5px solid rgba(255, 255, 255, 0.715);
    }
    img {
      position: absolute;
      bottom: 15px;
      left: 15px;
      width: 85%;
      text-align: center;
    }
  }
  .content-right {
    overflow: auto;
    background: #f7f7f8;
    flex: 1;
    height: 95vh;
    height: calc(100vh - 80px);
  }
}

.el-icon-questio {
  font-size: 22px;
  // background-color: #444;
  width: 190px;
  height: 50px;
  font-size: 16px;
  color: #3bc492;
  font-weight: 600;
  .phone-box {
    color: #3bc492;
    font-size: 23px;
  }
}
.hover-i {
  float: right;
  color: rgba(131, 143, 153, 1);
  font-size: 16px;
  cursor: pointer;
  position: relative;
  &:hover {
    &:after {
      position: absolute;
      bottom: -30px;
      right: 0px;
      width: 300px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      font-size: 12px;
      color: rgba(44, 45, 58, 1);
      text-align: center;
      background: rgba(243, 245, 247, 1);
      border-radius: 4px;
      content: "如有疑问，请致电客服热线：18971608045";
    }
  }
}

.active {
  color: rebeccapurple;
}
.el-dropdown-link {
  cursor: pointer;
}
.index {
  .dialog-footer {
    padding-bottom: 80px;
  }
  .btn-container {
    text-align: center;
  }
}

.router-link {
  display: inline-block;
  margin-left: 40px;
  > a {
    display: inline-block;
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(131, 143, 153, 1);
    &.active {
      color: #152436;
      border-bottom: 2px solid #3bc492;
    }
  }
}
/deep/.el-button--success {
  /*font-weight: 600;*/
  font-size: 17px;
  font-family: PingFangSC-Semibold;
}
</style>
